(function () {

    'use strict';

    module.exports = ParamsCtrl;

    ParamsCtrl.$inject = ["$translate", "$state", "$transitions", "$scope", "configService", "authService"];

    function ParamsCtrl($translate, $state, $transitions, $scope, configService, authService) {
        let vm = this;
        const parameters = require('../json/parametres.json');

        vm.key = '';

        vm.$onInit = init;

        vm.showItem = showItem;
        vm.filterMenu = filterMenu;
        vm.clearKey = clearKey;

        function init() {
            vm.parameters = parameters;

            let listener = $transitions.onStart({}, toList);

            if ($state.$current['name'] === "app.parameters") $state.go("app.parameters.general", {});

            function toList(transition) {
                let toState = transition.to();

                if (!_.eq(toState.name, "app.parameters.general") && _.eq(toState.name, "app.parameters")) {
                    $state.go("app.parameters.general", {});
                }
            }

            $scope.$on("$destroy", onDestroy);

            function onDestroy() {
                listener();
            }
        }


        function showItem(item) {
            const showList = _.get(item, "show", []);
            const hideList = _.get(item, "hide", []);
            const show = _.isEmpty(showList) ? true : _.reduce(showList, handleConditions, true);
            const hide = _.isEmpty(hideList) ? false : _.reduce(hideList, handleConditions, true);

            return show && !hide;

            function handleConditions(result, item) {
                if (item === 'is_root') {
                    return result && authService.isRootProfile();
                } else if (item === "has_special_power") {
                    return result && authService.hasSpecialPower();
                } else if (_.has(configService.activeModules, item)) {
                    return result && _.get(configService.activeModules, item);
                } else if (_.isObject(item)) {
                    return result && authService.aclHandler(item);
                } else {
                    return result;
                }
            }
        }

        function filterMenu() {
            if (!vm.key || vm.key.trim() === '') {
                vm.parameters = parameters;
                return;
            }

            const key = _.deburr(vm.key.toLowerCase());
            const filtered = parameters.reduce((result, parameter) => {
                const groupLabel = _.deburr($translate.instant(parameter.label).toLowerCase());

                if (groupLabel.includes(key)) {
                    result.push(parameter);
                } else {
                    const matchedItems = parameter.items.filter(item => {
                        const itemLabel = _.deburr($translate.instant(item.label).toLowerCase());
                        return itemLabel.includes(key);
                    });

                    if (matchedItems.length > 0) {
                        result.push({ label: parameter.label, items: matchedItems });
                    }
                }

                return result;
            }, []);

            vm.parameters = filtered;
        }

        function clearKey() {
            vm.key = '';
            vm.parameters = parameters;
        }
    }

})();


